import { useLocation } from 'react-router-dom';

import {
  appendReferer,
  useOperationalEvent,
  usePageViewedEvent,
} from '../../../utilities/analytics/analytics-web-client';

import { loginPageId } from '../constants';
import { useAppendReasonViewingScreen } from './utility';

export const useLoginPageViewed = () => {
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);

  const appendReasonViewingScreen = useAppendReasonViewingScreen();

  usePageViewedEvent(loginPageId, {
    ...appendReferer(appendReasonViewingScreen({})),
    noAccess: !!queryParams.get('tenant'),
  });

  useOperationalEvent({
    page: loginPageId,
    action: 'loadLoginPageSuccessful',
    subject: 'sli',
  });
};
